import { OfferApi, OfferParams } from './offer'

export const PIPELINE_ID = {
  'en-US': {
    o: 1,
    'o-795': 81,
    'o-1295': 77,
    'o-1495': 274,
    'o-2995': 200,
    'o-test-paydoo': 235,
  },
  'en-IE': {
    o: 2,
    'o-795': 82,
    'o-1295': 76,
  },
  'en-PH': {
    'o-699-php-metric-cppv3': 281,
  },
  'cs-CZ': {
    o: 3,
    'o-199': 80,
    'o-329': 75,
  },
  'en-GB': {
    o: 34,
    'o-test-primer': 277,
  },
  'es-ES': {
    o: 67,
    'o-795': 83,
    'o-1295': 72,
    'o-1495': 268,
    'o-usd': 73,
    'o-usd-795': 84,
    'o-usd-1295': 74,
    'o-usd-1495': 269,
    'o-mxn-299': 203,
    'o-mxn-329': 270,
  },
  'es-MX': {
    'o-299': 232,
  },
  'es-AR': {
    'o-1549': 233,
    'o-usd-1295': 265,
    'o-3300-ars-metric': 315,
    'o-10999-ars-1295-ar-metric': 348,
  },
  'de-DE': {
    o: 68,
    'o-995': 71,
    'o-1495': 271,
  },
  'lt-LT': {
    o: 69,
    'o-795': 78,
    'o-1295': 110,
  },
  'et-EE': {
    o: 70,
    'o-795': 79,
    'o-1295': 111,
  },
  'fr-FR': {
    o: 85,
    'o-795': 86,
    'o-1295': 87,
    'o-1495': 272,
    'o-usd': 88,
    'o-usd-795': 89,
    'o-usd-1295': 90,
    'o-usd-1495': 273,
  },
  'el-GR': {
    o: 103,
    'o-795': 104,
    'o-1295': 112,
  },
  'ro-RO': {
    o: 100,
    'o-795': 107,
    'o-1295': 114,
    'o-ron': 108,
    'o-ron-35': 109,
    'o-ron-49': 113,
    'o-ron-65': 117,
  },
  'ru-RU': {
    o: 101,
    'o-795': 106,
    'o-1295': 199,
  },
  'hu-HU': {
    o: 102,
    'o-795': 105,
    'o-1999': 116,
    'o-3499': 115,
    'o-4499': 201,
    'o-4999': 202,
    'o-1295-eur-metric': 318,
  },
  'sk-SK': {
    o: 118,
    'o-1295': 119,
  },
  'pt-PT': {
    o: 120,
    'o-1295': 121,
    'o-1495': 275,
    'o-usd': 133,
    'o-usd-1295': 134,
    'o-usd-1495': 276,
  },
  'pt-BR': {
    'o-6995': 234,
  },
  'bg-BG': {
    o: 122,
    'o-2499': 123,
  },
  'hr-HR': {
    o: 124,
    'o-1295': 125,
    'o-hrk-6995': 126,
    'o-hrk-9495': 127,
  },
  'pl-PL': {
    o: 166,
    'o-1295': 267,
    'o-5995': 167,
  },
  'en-CA': {
    'o-1795': 266,
  },
  'nl-NL': {
    'o-1295-eur-metric': 279,
    'o-1295-usd-metric': 280,
  },
  'da-DK': {
    'o-9995-dkk-metric': 282,
    'o-6995-dkk-metric': 283,
  },
  'it-IT': {
    'o-1295-eur-metric': 284,
  },
  'ka-GE': {
    'o-3499-gel-metric': 285,
  },
  'bs-BA': {
    'o-2495-bam-metric': 286,
  },
  'uk-UA': {
    'o-1295-usd-metric': 287,
    'o-479-uah-metric': 288,
  },
  'sr-RS': {
    'o-1199-rsd-metric': 289,
    'o-1499-rsd-metric': 312,
    'o-1295-eur-metric': 317,
  },
  'en-ZA': {
    'o-219-zar-metric': 314,
  },
  'en-NZ': {
    'o-1995-nzd-metric': 313,
  },
  'en-AU': {
    'o-2495-aud-metric': 316,
  },
  'no-NO': {
    'o-13995-nok-1295-metric': 345,
  },
  'sv-SE': {
    'o-139-sek-1295-metric': 346,
  },
  'fi-FI': {
    'o-1295-eur-metric': 347,
  },
}

export const API_ORDER_KEYS = [
  'age',
  'name',
  'gender',
  'height',
  'weight',
  'goal_weight',
  'unit_system',
]

export type ContextOrder = {
  orderId: number
  pipeLineId: number
  name: string
  weight: number
  height: number
  age: string
  gender: string
  goalWeight: number
  measurementSystem: string
}

export type Utms = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
}

export type UpdateValues = {
  email?: string
  meta?: Meta
}

type Meta = {
  age?: number
  name?: string
  gender?: string
  height?: number
  weight?: number
  goal_weight?: number
  unit_system?: string
}

export type Order = {
  id: number
  pipeline_id: number
  meta: Meta
  coloring_id: number
  coloring: Utms
  ip: string
  email?: string
  access_token?: string
  chance: boolean
  custom_data?: CustomData
}

export type User = {
  id: number
  access_token: string
}

export type CheckoutApi = {
  offer: OfferApi
  order: Order
  user: User
}

export type SignupUserApi = {
  access_token: string
  offer: OfferParams
  user_id: number
}

export interface ApiResponse<T> {
  data?: T
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RequestBody {}

export enum SignupErrors {
  email = 'email',
  default = 'default',
}

export const LAST_CHANCE_MODAL = 'lastchance'

export type CustomData = {
  [key: string]: any
}
